export type TransientSequenceError = {
  sequenceId: string;
  message: string;
};

export type SequenceState = {
  searchUnsequencedAdsTerm: string;
  uniqueParentLineOmsLinkIds: string[];
  lineItemIdList: string[];
  sequencedAdsOrder: Map<string, number>;
  transientSequenceError: TransientSequenceError | null;
};

export const SEQUENCE_INITIAL_STATE: SequenceState = {
  searchUnsequencedAdsTerm: '',
  sequencedAdsOrder: new Map(),
  uniqueParentLineOmsLinkIds: [],
  lineItemIdList: [],
  transientSequenceError: null,
};
